import type { ReactNode } from 'react';
import { useId } from 'react';
import Tooltip from '@/components/Tooltip';

type TooltipProps =
  | {
      tooltip: ReactNode;
      labelTerm: ReactNode;
    }
  | {
      tooltip?: never;
      labelTerm?: never;
    };

type Props = {
  children: ReactNode;
  label: ReactNode;
} & TooltipProps;

export const LabelledValue = ({
  label,
  labelTerm,
  children,
  tooltip,
}: Props) => {
  const id = useId();
  return (
    <div className="grid grid-cols-[auto_auto] justify-between text-solid">
      <div className="text-xs" id={id}>
        {label}{' '}
        {tooltip && (
          <Tooltip
            title={
              <p className="m-0 max-w-[200px] text-tiny text-p-grey-30">
                {tooltip}
              </p>
            }
            light
          >
            <span className="bg-brand-01/10 inline-block cursor-help whitespace-nowrap border-0 border-b border-dotted border-brand-01">
              {labelTerm}
            </span>
          </Tooltip>
        )}
      </div>
      {children && (
        <div className="text-xs" aria-labelledby={id}>
          {children}
        </div>
      )}
    </div>
  );
};
